import setReduxAction from '../../../redux/actions/set'
import { REFERENCES_ACTION } from '../../constants'
import addReferenceUtil from '../../utils/add'

function addReferenceAction (payload) {
  return (dispatch, getState) => {
    const addReferenceObj = addReferenceUtil({
      ...payload,
      state: getState()
    })
    // If the reference already exists, no-op
    if (!addReferenceObj) {
      return
    }
    dispatch(setReduxAction({
      type: REFERENCES_ACTION.ADD,
      payload: {
        path: addReferenceObj.referencesPath,
        value: addReferenceObj.newReferences,
        options: {
          step: 1
        }
      }
    }))
  }
}

export default addReferenceAction
